//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {
    mapState
  } from "vuex";

  export default {
    data() {
      return {
        noIndex: false,
      };
    },
    async beforeMount() {},
    mounted() {
      this.keepLang()
    },
    components: {},
    computed: {
      ...mapState([
        "categories", 'campaign', 'size'
      ])
    },
    methods: {
      goHomeWithSizeFilter(size) {
        this.$router.push({
          path: `/home/${this.$route.query.cid}`,
          query: {
            size: size,
            cid: this.$route.query.cid
          }
        })
      },
      goHomeWithFilter(typeId, catId) {
        this.$router.push({
          path: `/home/${this.$route.query.cid}`,
          query: {
            type: typeId,
            cat: catId,
            cid: this.$route.query.cid
          }
        })
      },
      keepLang() {
        let locale = localStorage.locale;
        this.$i18n.locale = locale === 'en' ? locale : 'zh';
        this.$i18n.locale = 'en';
      },
    },
    watch: {}
  };




// WEBPACK FOOTER //
// ./src/pages/cat/Cat.vue